import ValueX from '../types/ValueX';

export default class DiagnosisX extends ValueX {
    static __className = 'DiagnosisX';

    constructor(constructJson) {
        super(constructJson, 'diagnosis', 'DiagnosisX');
    }
}
